import React from 'react';
import useTheme from '../theme/useTheme';
import { Moon, Sun } from 'lucide-react';
import { cn } from '../lib/utils';

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();

  return (
    <div 
      className="relative flex items-center p-1 bg-zinc-200/50 dark:bg-zinc-800/50 rounded-full cursor-pointer group hover:bg-zinc-300/50 dark:hover:bg-zinc-700/50 transition-all duration-300"
      onClick={toggle}
      title={`Switch to ${theme === 'dark' ? 'Light' : 'Dark'} Mode`}
    >
      {/* Sliding Background Indicator */}
      <div 
        className={cn(
          "absolute h-7 w-7 bg-[#FF7D00] rounded-full shadow-lg shadow-orange-500/20 transition-all duration-500 ease-in-out",
          theme === 'dark' ? "translate-x-7" : "translate-x-0"
        )}
      />

      {/* Sun Icon */}
      <div className="relative z-10 p-1">
        <Sun className={cn(
          "h-5 w-5 transition-colors duration-500",
          theme === 'light' ? "text-white" : "text-zinc-500 dark:text-zinc-400"
        )} />
      </div>

      {/* Moon Icon */}
      <div className="relative z-10 p-1">
        <Moon className={cn(
          "h-5 w-5 transition-colors duration-500",
          theme === 'dark' ? "text-white" : "text-zinc-500 dark:text-zinc-400"
        )} />
      </div>
    </div>
  );
}
